import AdminPushHttpService from 'dataStore/service/adminPush.service'

/**
 * Отписывает текущее устройство от Web Push и удаляет подписку на сервере.
 */
export const unsubscribeAdminPush = async (): Promise<void> => {
  if (!('serviceWorker' in navigator)) {
    return
  }

  try {
    const registration = await navigator.serviceWorker.ready
    const subscription = await registration.pushManager.getSubscription()
    if (!subscription) {
      return
    }
    const endpoint = subscription.endpoint
    await subscription.unsubscribe()
    if (endpoint) {
      await AdminPushHttpService.deleteSubscription(endpoint)
    }
  } catch (error) {
    console.error('Ошибка отписки Web Push:', error)
  }
}
